export default __webpack_public_path__ + "static/media/28_tag_induction-cooker.e24ebe28.svg";